import React, { useEffect, useRef } from 'react';
import Input from '@material-ui/core/Input';
import styles from 'assets/jss/material-dashboard-pro-react/components/otpStyle';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

interface ISingleOTPInputProps {
	focus: boolean;
	value: string;
	onChange: (event: React.ChangeEvent<{ value: string }>) => void;
	onKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
	handleFocus: (event: React.FocusEvent<HTMLInputElement>) => void;
	onInput: (event: React.FormEvent<HTMLInputElement>) => void;
	error?: boolean;
	isNewDashBoardEnabled?: boolean;
}

// @ts-ignore
const useStyles = makeStyles(styles);

const SingleOTPInput = ({
	focus,
	value,
	onChange,
	onKeyDown,
	handleFocus,
	onInput,
	error,
	isNewDashBoardEnabled,
}: ISingleOTPInputProps) => {
	const classes = useStyles({ isNewDashBoardEnabled });
	const input = useRef<HTMLInputElement>(null);

	useEffect(() => {
		if (focus && !!input) {
			// @ts-ignore
			input?.current.focus();
		}
	}, [focus]);

	const inputClasses = classNames(classes.input, {
		[classes.newThemedOtpInput]: isNewDashBoardEnabled,
	});

	return (
		<div className={classes.singleInputWrapper}>
			<Input
				fullWidth
				inputRef={input}
				value={value || ''}
				classes={{
					input: inputClasses,
				}}
				inputProps={{
					maxLength: 1,
				}}
				onChange={onChange}
				onKeyDown={onKeyDown}
				onFocus={handleFocus}
				onInput={onInput}
				error={error}
			/>
		</div>
	);
};

export default SingleOTPInput;
